<script setup lang="ts">
type Props = {
  label: string;
  hasCloseButton?: boolean;
};

const { label } = defineProps<Props>();
</script>

<template>
  <button
    type="button"
    class="rounded-full px-3 py-2 bg-gray-50 border border-platform-border-1 text-platform-text-1 text-sm hover:bg-gray-100 transition-colors duration-200 cursor-pointer"
  >
    <div class="flex items-center justify-center gap-1">
      <span class="line-clamp-1">{{ label }}</span>
      <BaseIcon
        v-if="hasCloseButton"
        name="circleCloseFill"
        class="mt-0.5 text-platform-text-3"
        :size="16"
      />
    </div>
  </button>
</template>
